<template>
  <vs-popup class="create-csutomer-crm-contact" id="popup"
    :title="isCreateMode ? `CREATE CONTACT REPORT [${form.type}]` : `UPDATE CONTACT REPORT [${form.type}]`"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-csutomer-crm-contact-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Scheduled Timestamp</small>
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:ss' }" class="hidden"
                  v-model="form.scheduled_timestamp" placeholder="Choose Date" />
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:ss' }" class="w-full"
                  v-model="form.scheduled_timestamp" placeholder="Choose Date & Time" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Type</small>
                <v-select disabled name="timescale_type" :closeOnSelect="true" :clearable="false" v-model="form.type"
                  :options="['email','event', 'call', 'f2f-meeting', 'other']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div> -->


          <div class="mb-3 vx-row" v-if="form.type === 'f2f-meeting'">
            <div class="w-full vx-col">
              <ValidationProvider vid="location" name="location" rules="required" v-slot="{ errors }">
                <small class="label">Location</small>
                <vs-input v-model="form.location" name="location" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row mt-4">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="customer_users" name="customer_users" rules="" v-slot="{ errors }">
                <small class="label">Customer Users from System</small>
                <v-select name="timescale_type" :closeOnSelect="false" :clearable="false"
                  v-model="selected_customer_users_ids" :options="customer_users_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="option => option.id" label="full_name" multiple />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row ml-1">
            <small class="label">New Customer Users</small>
          </div>

          <div class="mb-3 vx-row mt-2" v-for="(user, index) in selected_customer_users">
            <div class="w-full vx-col md:w-1/4 md:mb-0">
              <ValidationProvider :vid="`email_${index}`" :name="`email_${index}`" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="selected_customer_users[index].email" :name="`email_${index}`" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/4 md:mb-0">
              <ValidationProvider :vid="`first_name_${index}`" :name="`first_name_${index}`" rules="required"
                v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="selected_customer_users[index].first_name" :name="`first_name_${index}`" class="w-full"
                  label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                  val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/4 md:mb-0">
              <ValidationProvider :vid="`last_name_${index}`" :name="`last_name_${index}`" rules="required"
                v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="selected_customer_users[index].last_name" :name="`last_name_${index}`" class="w-full"
                  label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                  val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/4 md:mb-0">
              <vs-button @click.stop="removeNewUser(index)" class="ml-3 w-full mt-6" size="small" color="danger"
                type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
            </div>
          </div>
          <vs-button @click="addNewUser" class="mt-2 ml-auto" size="small">Add new user</vs-button>


          <div class="mb-3 mt-8 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="staff" name="staff" rules="required" v-slot="{ errors }">
                <small class="label">ITS Staff Involved</small>
                <v-select name="timescale_type" :closeOnSelect="false" :clearable="false" v-model="form.staff"
                  :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name"
                  multiple />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="subject" name="subject" rules="required" v-slot="{ errors }">
                <small class="label">Subject</small>
                <v-select name="subject" :closeOnSelect="true" :clearable="false" v-model="form.subject"
                  :options="subjects_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.name" label="name" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="discussion" name="discussion" rules="max:5000" v-slot="{ errors }">
                <small class="label">Discussion</small>
                <small class="label float-right text-warning font-bold">{{ form.discussion.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.discussion" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="requirements" name="requirements" rules="max:5000" v-slot="{ errors }">
                <small class="label">Requirements</small>
                <small class="label float-right text-warning font-bold">{{ form.requirements.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.requirements" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="follow_up_timestamp" name="follow_up_timestamp" rules="" v-slot="{ errors }">
                <small class="label">Follow Up Timestamp</small>
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:ss' }" class="hidden"
                  v-model="form.follow_up_timestamp" placeholder="Choose Date" />
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:ss' }" class="w-full"
                  v-model="form.follow_up_timestamp" placeholder="Choose Date & Time" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="max:5000" v-slot="{ errors }">
                <small class="label">Next Action</small>
                <small class="label float-right text-warning font-bold">{{ form.notes.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const DropDownRepository = RepositoryFactory.get('drop_down')
const CrmRepository = RepositoryFactory.get('crm')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import vSelect from 'vue-select'

import { mapActions, mapGetters } from 'vuex';

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      timestamp: '',
      staff: [],
      requirements: '',
      subject: '',
      discussion: '',
      notes: '',
      type: ''
    },
    isCreateMode: true,
    customer_users_list: [],
    selected_customer_users_ids: [],
    selected_customer_users: [],
    subjects_list: []
  }
}

export default {
  name: 'CreateCustomerCrmContactPopUp',
  data() {
    return initialState()
  },
  props: {
    customer_id: {
      default: ''
    }
  },
  methods: {
    ...mapActions(['fetchStaffs']),
    async openPopup(contact_type, id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.form.type = contact_type
        this.fetchCustomerUsers()
        this.fetchCrmCustomerSubjects()
        this.fetchStaffs()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchIncotermDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchCustomerUsers() {
      try {
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customer_id)).data
        this.customer_users_list = data
      } catch (error) {

      }
    },
    async fetchCrmCustomerSubjects() {
      try {
        const { data } = (await DropDownRepository.getCustomerCrmSubjectList()).data
        this.subjects_list = data
      } catch (error) {

      }
    },
    async fetchIncotermDetails() {
      await this.$vs.loading({
        container: '#create-csutomer-crm-contact-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CrmRepository.getCustomerCrmContact(this.id)).data
        this.form = data
        this.form.staff = data.staff.map((x) => x.id)
        this.selected_customer_users_ids = data.customer_users.filter((x) => !!x.id).map((x) => x.id)
        this.selected_customer_users = data.customer_users.filter((x) => !x.id)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-contact-popup > .con-vs-loading')
    },
    async onClickCreateSite() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-csutomer-crm-contact-popup',
        scale: 0.45
      })
      try {
        const users_from_system = this.selected_customer_users_ids.map((x) => {
          const find = this.customer_users_list.find((y) => y.id === x)
          return { id: find.id, first_name: find.first_name, last_name: find.last_name, email: find.email }
        })
        this.form.customer_users = [...users_from_system, ...this.selected_customer_users.map((x) => ({ email: x.email, first_name: x.first_name, last_name: x.last_name }))]

        if (this.isCreateMode) {
          this.form.customer_id = this.customer_id
          await CrmRepository.createCustomerCrmContact(this.form);
          this.showSuccessMessage('Customer crm contact added!');
        } else {
          await CrmRepository.updateCustomerCrmContact(this.id, this.form);
          this.showSuccessMessage('Customer crm contact updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e);
        this.$vs.loading.close('#create-csutomer-crm-contact-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-contact-popup > .con-vs-loading')
    },
    removeNewUser(index) {
      this.selected_customer_users.splice(index, 1)
    },
    addNewUser() {
      this.selected_customer_users.push({ email: '', first_name: '', last_name: '' })
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect
  },
  computed: {
    ...mapGetters(['staffs'])
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-csutomer-crm-contact>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}
</style>
